<div class="container">
  <div class="content">
    <router-outlet></router-outlet>
  </div>
</div>

<app-image-preview-popup></app-image-preview-popup>
